<div style="display: flex; flex-direction: column; height: 100%; width: 100%; background: #FFF; font-family: 'Gilroy', sans-serif !important; color: #0F172A;">

  <!-- Drawer Header -->
  <div class="rp-drawer-header">
    <div class="rp-drawer-close-row">
      <button class="rp-close-btn" (click)="closeDrawer()">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
      <span class="rp-close-label" (click)="closeDrawer()">Close</span>
    </div>

    <div class="drawer-title-row" style="display: flex; align-items: center; gap: 8px; margin-bottom: 8px;">
      <h2 class="rp-drawer-title" style="margin: 0;">#TXN-{{ selectedPayment?.iqp_tran_id }}</h2>
    </div>
    <p class="rp-drawer-subtitle" style="margin-bottom: 20px;">PAYMENT &amp; AUDIT LEDGER</p>
  </div>

  <!-- Drawer Body -->
  <div class="drawer-body" *ngIf="selectedPayment">

    <!-- Meta card -->
    <div class="drawer-card">
      <div class="meta-grid-2">
        <app-detail-field
          label="Customer register"
          customClass="mb-0"
          [value]="selectedPayment?.contact_name || selectedPayment?.contact_first_name">
        </app-detail-field>
        <app-detail-field
          label="Transaction date"
          customClass="mb-0"
          [value]="formatPaymentDate(selectedPayment?.iqp_paid_date)">
        </app-detail-field>
      </div>
      <hr class="drawer-divider">
      <div class="meta-grid-2">
        <app-detail-field
          label="Associated invoice"
          customClass="mb-0"
          [value]="selectedPayment?.invoice_number || selectedPayment?.iqp_invoice_number || '-'">
        </app-detail-field>
        <app-detail-field
          label="Transaction amount"
          customClass="mb-0"
          [value]="selectedPayment?.iqp_partly_pmnt_amnt ? (selectedPayment?.iqp_partly_pmnt_amnt | divide) : '-'">
        </app-detail-field>
      </div>
      <hr class="drawer-divider">
      <div class="meta-grid-2">
        <app-detail-field
          label="UTR / Reference ID"
          customClass="mb-0"
          [value]="selectedPayment?.iqp_payment_ref || '-'">
        </app-detail-field>
        <app-detail-field label="Settlement method" customClass="mb-0" [fallback]="''">
          <div class="meta-value-method">
            <span class="method-dot"></span>
            <app-value [value]="selectedPayment?.iqp_payment_type || 'HDFC IMPS Transfer'"></app-value>
          </div>
        </app-detail-field>
      </div>
      <div *ngIf="selectedPayment?.doc_url">
        <hr class="drawer-divider">
        <app-label text="Attached document" style="margin-bottom: 8px; display: block;"></app-label>
        <a [href]="selectedPayment.doc_url" target="_blank" rel="noopener noreferrer" style="text-decoration: none; display: block;">
          <div class="attachment-item clickable-attachment">
            <div class="attachment-item__left">
              <div class="attachment-item__icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14 2 14 8 20 8"></polyline>
                  <line x1="16" y1="13" x2="8" y2="13"></line>
                  <line x1="16" y1="17" x2="8" y2="17"></line>
                </svg>
              </div>
              <div class="attachment-item__info">
                <p class="attachment-item__name">{{ selectedPayment?.doc_name || 'Payment Document' }}</p>
              </div>
            </div>
            <div class="attachment-item__actions">
              <span class="attachment-item__badge">
                Uploaded
              </span>
            </div>
          </div>
        </a>
      </div>
    </div>

    <!-- Reconciliation card -->
    <div class="drawer-card" *appHasAccess="'SALES_PAYMENT'">
      <app-section-header
        title="Reconciliation Control Matrix"
        [noBorder]="true"
        customClass="recon-section-header">
      </app-section-header>
      <div class="recon-grid">
        <app-button
          variant="primary"
          size="small"
          [disabled]="selectedPayment?.is_deleted || selectedPayment?.status === 101 || selectedPayment?.iqp_status === 'Verified'"
          (btnClick)="verifyPayment()">
          <span class="d-flex align-items-center gap-2">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="16" height="16">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span>Verify</span>
          </span>
        </app-button>

        <app-button
          variant="outline"
          size="small"
          [disabled]="selectedPayment?.is_deleted || selectedPayment?.status === 102 || selectedPayment?.iqp_status === 'Disputed'"
          (btnClick)="flagDisputedPayment()">
          <span class="d-flex align-items-center gap-2">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="16" height="16">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
            <span>Flag Dispute</span>
          </span>
        </app-button>
      </div>
    </div>

    <!-- Audit Timeline -->
    <div>
      <app-section-header
        title="Chronological Audit Timeline"
        [noBorder]="true"
        customClass="timeline-section-header">
        <span class="timeline-count font-title">
          <span class="tcount-dot status-pulse"></span> {{ auditTrailLogs.length + currentNotes.length +
          currentLogs.length }} EVENTS LOGGED
        </span>
      </app-section-header>

      <app-audit-trail>
        <!-- Custom auditor notes -->
        <app-audit-trail-node
          *ngFor="let note of currentNotes"
          title="Custom Auditor Note"
          [time]="note.time"
          [description]="note.text"
          dotColor="emerald"
          [isNote]="true">
        </app-audit-trail-node>

        <!-- Dynamic system logs -->
        <app-audit-trail-node
          *ngFor="let log of currentLogs"
          [title]="log.title"
          [time]="log.time"
          [description]="log.text"
          [dotColor]="log.isDisputed ? 'rose' : 'dark'"
          [titleColor]="log.isDisputed ? 'rose' : 'default'">
        </app-audit-trail-node>

        <!-- Real audit trail logs from API -->
        <app-audit-trail-node
          *ngFor="let log of auditTrailLogs; let last = last"
          [title]="formatOperationTitle(log.operation)"
          [time]="formatAuditTime(log.add_time)"
          [description]="formatOperationDescription(log)"
          [dotColor]="getOperationDotClass(log)"
          [titleColor]="getOperationTitleClass(log)"
          [isLast]="last">
        </app-audit-trail-node>
      </app-audit-trail>
    </div>

  </div><!-- /drawer-body -->

</div>
